import { Type } from '@sinclair/typebox';
export const NumericSchema = Type.String({
    pattern: String.raw `^[0-9]+(\.[0-9]+)?$`,
});
/**
 * Returns the latest of the given ISO-8601 UTC timestamps, ignoring undefined.
 * Relies on lexicographic ordering, valid only for same-format UTC strings.
 */
export const maxIsoTimestamp = (...values) => values
    .filter((value) => value !== undefined)
    .sort()
    .at(-1);
//# sourceMappingURL=common.js.map